import { render, staticRenderFns } from "./SmsSignatureComponent.vue?vue&type=template&id=23c8af6c&scoped=true"
import script from "./SmsSignatureComponent.vue?vue&type=script&lang=js"
export * from "./SmsSignatureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c8af6c",
  null
  
)

export default component.exports